export enum Permission {
	CREATE_ORG = 'CREATE_ORG',
	DELETE_ORG = 'DELETE_ORG',
	READ_ORG = 'READ_ORG',
	CAR_LIST_BAND_READ = 'SEGMENT_READ',
	CAR_LIST_BAND_WRITE = 'SEGMENT_WRITE',
	INVITE_USER = 'INVITE_USER',
	VEHICLE_READ = 'VEHICLE_READ',
	VEHICLE_WRITE = 'VEHICLE_WRITE',
	SITE_READ = 'SITE_READ',
	SITE_WRITE = 'SITE_WRITE',
	ROLE_READ = 'ROLE_READ',
	ROLE_WRITE = 'ROLE_WRITE',
	USER_READ = 'USER_READ',
	USER_WRITE = 'USER_WRITE',
	RUN_SIMULATION = 'RUN_SIMULATION',
	VIEW_SIMULATION = 'VIEW_SIMULATION',
	CAR_MODEL_READ = 'CAR_MODEL_READ',
	CAR_MODEL_WRITE = 'CAR_MODEL_WRITE',
	STOCK_READ = 'STOCK_READ',
	STOCK_WRITE = 'STOCK_WRITE',
	SERVICE_READ = 'SERVICE_READ',
	SERVICE_WRITE = 'SERVICE_WRITE',
	PACKAGE_DEAL_READ = 'PACKAGE_DEAL_READ',
	PACKAGE_DEAL_WRITE = 'PACKAGE_DEAL_WRITE',
	ELECTRIFICATION_WIZARD_READ = 'ELECTRIFICATION_WIZARD_READ',
	ELECTRIFICATION_WIZARD_WRITE = 'ELECTRIFICATION_WIZARD_WRITE',
	PARK_AREA_READ = 'PARK_AREA_READ',
	PARK_AREA_WRITE = 'PARK_AREA_WRITE',
	PRODUCT_READ = 'PRODUCT_READ',
	PRODUCT_WRITE = 'PRODUCT_WRITE',
	ASSESMENT_READ = 'ASSESMENT_READ',
	ASSESMENT_WRITE = 'ASSESMENT_WRITE',
	QUOTATION_READ = 'QUOTATION_READ',
	QUOTATION_WRITE = 'QUOTATION_WRITE',
	DAILYTASKS_READ = 'ELECTRIFICATION_DAILYTASKS_READ',
	DAILYTASKS_WRITE = 'ELECTRIFICATION_DAILYTASKS_WRITE'
}

export const isPermissionVisible = (permission: Permission): boolean => {
	return ![Permission.CAR_MODEL_READ, Permission.CAR_MODEL_WRITE].includes(permission);
};

export const getDescriptionTranslationKey = (permission: Permission): string => {
	const map: Record<Permission, string> = {
		[Permission.CREATE_ORG]: 'roles.permission-description.org-create',
		[Permission.DELETE_ORG]: 'roles.permission-description.org-delete',
		[Permission.READ_ORG]: 'roles.permission-description.org-read',
		[Permission.CAR_LIST_BAND_READ]: 'roles.permission-description.car-list-band-read',
		[Permission.CAR_LIST_BAND_WRITE]: 'roles.permission-description.car-list-band-write',
		[Permission.INVITE_USER]: 'roles.permission-description.user-invite',
		[Permission.VEHICLE_READ]: 'roles.permission-description.vehicle-read',
		[Permission.VEHICLE_WRITE]: 'roles.permission-description.vehicle-write',
		[Permission.SITE_READ]: 'roles.permission-description.site-read',
		[Permission.SITE_WRITE]: 'roles.permission-description.site-write',
		[Permission.ROLE_READ]: 'roles.permission-description.role-read',
		[Permission.ROLE_WRITE]: 'roles.permission-description.role-write',
		[Permission.USER_READ]: 'roles.permission-description.user-read',
		[Permission.USER_WRITE]: 'roles.permission-description.user-write',
		[Permission.RUN_SIMULATION]: 'roles.permission-description.run-simulation',
		[Permission.VIEW_SIMULATION]: 'roles.permission-description.view-simulation',
		[Permission.CAR_MODEL_READ]: 'roles.permission-description.car-model-read',
		[Permission.CAR_MODEL_WRITE]: 'roles.permission-description.car-model-write',
		[Permission.STOCK_READ]: 'roles.permission-description.stock-read',
		[Permission.STOCK_WRITE]: 'roles.permission-description.stock-write',
		[Permission.SERVICE_READ]: 'roles.permission-description.service-read',
		[Permission.SERVICE_WRITE]: 'roles.permission-description.service-write',
		[Permission.PACKAGE_DEAL_READ]: 'roles.permission-description.package-deal-read',
		[Permission.PACKAGE_DEAL_WRITE]: 'roles.permission-description.package-deal-write',
		[Permission.ELECTRIFICATION_WIZARD_READ]: 'roles.permission-description.electrification-wizard-read',
		[Permission.ELECTRIFICATION_WIZARD_WRITE]: 'roles.permission-description.electrification-wizard-write',
		[Permission.PARK_AREA_READ]: 'roles.permission-description.park-area-read',
		[Permission.PARK_AREA_WRITE]: 'roles.permission-description.park-area-write',
		[Permission.PRODUCT_READ]: 'roles.permission-description.product-read',
		[Permission.PRODUCT_WRITE]: 'roles.permission-description.product-write',
		[Permission.ASSESMENT_READ]: 'roles.permission-description.assesment-read',
		[Permission.ASSESMENT_WRITE]: 'roles.permission-description.assesment-write',
		[Permission.QUOTATION_READ]: 'roles.permission-description.quotation-read',
		[Permission.QUOTATION_WRITE]: 'roles.permission-description.quotation-write',
		[Permission.DAILYTASKS_READ]: 'roles.permission-description.dailytasks-read',
		[Permission.DAILYTASKS_WRITE]: 'roles.permission-description.dailytasks-write'
	};
	return map[permission];
};
